// An item's price history chart on its Einkauf tab (docs/suppliers.md, "Preisverlauf").
export default {
  title: "Price history",
  // Under the title, the axis' unit appended in code ("Price per supplier in EUR / t").
  subtitle: "Price per supplier in",
  months: "{n} months",
  period: "Period",
  currency: "Currency",
  today: "Today",
  upcoming: "upcoming",
  empty: "No prices in this period",
  no_price_in: "no price in",
  // Behind a line when a machine's rows bill in different units: "Mietpark Nord (per wk)".
  per: "per",
  // Under the legend, the rows appended in code: rows per week or month beside hours are not drawn.
  other_unit: "Other unit, not shown:",
  aria: "Price history per supplier",
}
